import React from 'react'
import {
  Divider,
  Collapse,
  ListItemButton,
  Box,
  Button,
  Typography,
  Chip,
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone'
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone'
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch'
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone'
import HelpTwoToneIcon from '@mui/icons-material/HelpTwoTone'
import ChevronRightTwoToneIcon from '@mui/icons-material/ChevronRightTwoTone'
import { NavLink, useLocation } from 'react-router'
import PortfoliosSection from './PortfoliosSection'
import TrashSection from './TrashSection'
import MarketplacesSection from './MarketplacesSection'
import SettingsSection from './SettingsSection'
import SupportSection from './SupportSection'
import AdminSection from './AdminSection'
import DetailsSection from './DetailsSection'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import LotsSection from './LotsSection'
import SubmittedPropertiesSection from './SubmittedPropertiesSection'
import SharedPropertiesSection from './SharedPropertiesSection'
import ContactsSection from './ContactsSection'
import WarehouseIcon from '@mui/icons-material/Warehouse'
import UnifiedSubscribeDialog from '@/housefolios-components/Session/UnifiedSubscribeDialog'
import {
  sidebarChevronIndicatorSx,
  sidebarNavigationSx,
  sidebarNestedExternalLinkSx,
  sidebarNestedNavLinkSx,
} from '@/layout-blueprints/chromeComponentSx'

const SidebarNavigation = (props) => {
  // Destructure all necessary props here
  const {
    clsx,
    propertySearchOptions,
    toggleSidebarMobile,
    handlePortfolio,
    handleMarketplace,
    activePortfolioId,
    activeMarketplaceId,
    portfolios,
    portfoliosDropdownOpen,
    togglePortfoliosDropdown,
    openPortfolioOptions,
    selectedPortfolio,
    canDelete,
    anchorElMenu1,
    anchorElMenu2,
    handleClosePortfolioOptions,
    member,
    trashedProperties,
    anchorElTrashMenu,
    openTrashOptions,
    handleCloseTrashOptions,
    marketplaces,
    sharedMarketplaces,
    orgId,
    marketplacesDropdownOpen,
    toggleMarketplacesDropdown,
    openMarketplaceOptions,
    selectedMarketplace,
    anchorElMenu3,
    handleCloseMarketplaceOptions,
    urlAffiliate,
    settingsDropdownOpen,
    toggleSettingsDropdown,
    supportDropdownOpen,
    toggleSupportDropdown,
    setOpenFeedbackTour,
    openDialog,
    handleClose,
    handleClickOpen,
    session,
    adminDropdownOpen,
    toggleAdminDropdown,
    handleOpenHousefoliosAdmin,
    affiliateDropdownOpen,
    toggleAffiliateDropdown,
    submittedDropdownOpen,
    toggleSubmittedDropdown,
    sidebarToggle,
    ...rest
  } = props

  const [propertySearchDropdownOpen, setPropertySearchDropdownOpen] =
    React.useState(false)

  const location = useLocation()
  const showPropertySearch =
    Boolean(session?.me?.activeOrg?.isRealeflow) &&
    String(session?.me?.activeOrg?.member || '').toLowerCase() !==
      'pep'
  const [upgradeDialogOpen, setUpgradeDialogOpen] =
    React.useState(false)

  const activeOrg = session?.me?.activeOrg
  const activeMember = activeOrg?.member
  const isEligibleMember = ['astroflip', 'pacemorby'].includes(
    activeMember,
  )
  const isHotPlan = React.useMemo(() => {
    const subs = Array.isArray(activeOrg?.subscriptions)
      ? activeOrg.subscriptions
      : []
    return subs.some((s) => {
      if (!s || s.disabled) return false
      const rfId =
        s?.realeflowPlanId ?? s?.plan?.realeflowPlanId ?? null
      const planType = String(
        s?.planType || s?.planNickname || '',
      ).toLowerCase()
      const status = String(s?.status || '').toLowerCase()
      const activeish =
        status === '' ||
        ['active', 'trialing', 'past_due'].includes(status)
      const isHotById = ['1250', '1252', 1250, 1252].includes(rfId)
      const isHotByType = planType.includes('hot')
      return activeish && (isHotById || isHotByType)
    })
  }, [activeOrg])
  const shouldShowUpgradeCTA = isEligibleMember
  return (
    <Box sx={sidebarNavigationSx} data-hf="sidebar-nav">
      <ul>
        <li>
          <NavLink
            id="leftNavLaunchpad"
            onClick={toggleSidebarMobile}
            to="/launchpad"
          >
            <span data-hf="sidebar-icon">
              <RocketLaunchIcon />
            </span>
            Launchpad
          </NavLink>
        </li>
      </ul>
      <Divider />
      {showPropertySearch && (
      <ul>
        <li>
          {propertySearchOptions &&
          propertySearchOptions.length === 1 ? (
            <NavLink
              id="leftNavPropertySearch"
              to="/property-search"
            >
              <span data-hf="sidebar-icon">
                <SearchTwoToneIcon />
              </span>
              <span data-hf="sidebar-item-label">
                Property Search
              </span>
            </NavLink>
          ) : (
            <>
              <a
                id="leftNavPropertySearch"
                href="#/"
                onClick={(e) => {
                  e.preventDefault()
                  setPropertySearchDropdownOpen(
                    !propertySearchDropdownOpen,
                  )
                }}
                data-nav-active={propertySearchDropdownOpen || undefined}
              >
                <span data-hf="sidebar-icon">
                  <SearchTwoToneIcon />
                </span>
                <span data-hf="sidebar-item-label">
                  Property Search
                </span>
                <span
                  data-hf="sidebar-icon-indicator"
                  style={sidebarChevronIndicatorSx(propertySearchDropdownOpen)}
                >
                  <ChevronRightTwoToneIcon />
                </span>
              </a>
              <Collapse in={propertySearchDropdownOpen}>
                <ul>
                  {propertySearchOptions.map((option) => {
                    // Handle Creative MLS differently - open external URL
                    if (option === 'Creative MLS') {
                      return (
                        <li key={option}>
                          <NavLink
                            to="#"
                            onClick={(e) => {
                              e.preventDefault()
                              window.open(
                                'https://www.thecreativelisting.com/',
                                '_blank',
                              )
                            }}
                            style={sidebarNestedExternalLinkSx}
                          >
                            {option}
                          </NavLink>
                        </li>
                      )
                    }

                    // Handle regular property search options
                    const to = `/property-search?leadType=${encodeURIComponent(option)}`
                    const selected =
                      location.pathname === '/property-search' &&
                      location.search.includes(
                        `leadType=${encodeURIComponent(option)}`,
                      )
                    return (
                      <li key={option}>
                        <NavLink
                          to={to}
                          end
                          data-nav-active={selected || undefined}
                          style={sidebarNestedNavLinkSx}
                        >
                          {option}
                        </NavLink>
                      </li>
                    )
                  })}
                </ul>
              </Collapse>
            </>
          )}
        </li>
      </ul>
      )}
      <Divider />
      <ul>
        <li>
          <NavLink
            id="leftNavMyProperties"
            onClick={() => handlePortfolio(null)}
            to="/my-properties"
            data-nav-active={
              location.pathname === '/my-properties' && !activePortfolioId
                ? true
                : undefined
            }
            aria-current={
              location.pathname === '/my-properties' && !activePortfolioId
                ? 'page'
                : 'false'
            }
          >
            <span data-hf="sidebar-icon">
              <HomeTwoToneIcon />
            </span>
            My Properties
          </NavLink>
        </li>
      </ul>
      {/* Contacts available for PEP members only */}
      {session?.me?.activeOrg?.member === 'pep' && (
        <ContactsSection />
      )}
      {/* <LotsSection
        session={session}
        handlePortfolio={handlePortfolio}
      /> */}
      <SubmittedPropertiesSection
        session={session}
        submittedDropdownOpen={submittedDropdownOpen}
        toggleSubmittedDropdown={toggleSubmittedDropdown}
        handlePortfolio={handlePortfolio}
        handleMarketplace={handleMarketplace}
        activeMarketplaceId={activeMarketplaceId}
        clsx={clsx}
      />
      <SharedPropertiesSection
        session={session}
        handlePortfolio={handlePortfolio}
      />
      <Divider />
      <ul>
        <SettingsSection
          settingsDropdownOpen={settingsDropdownOpen}
          toggleSettingsDropdown={toggleSettingsDropdown}
          toggleSidebarMobile={toggleSidebarMobile}
          session={session}
        />
        <SupportSection
          supportDropdownOpen={supportDropdownOpen}
          toggleSupportDropdown={toggleSupportDropdown}
          setOpenFeedbackTour={setOpenFeedbackTour}
          urlAffiliate={urlAffiliate}
          openDialog={openDialog}
          handleClose={handleClose}
          handleClickOpen={handleClickOpen}
          session={session}
        />
      </ul>
      <Divider />
      <ul>
        <PortfoliosSection
          portfolios={portfolios}
          sharedPortfolios={session.me.activeOrg.sharedPortfolios}
          orgId={orgId}
          portfoliosDropdownOpen={portfoliosDropdownOpen}
          togglePortfoliosDropdown={togglePortfoliosDropdown}
          handlePortfolio={handlePortfolio}
          activePortfolioId={activePortfolioId}
          openPortfolioOptions={openPortfolioOptions}
          selectedPortfolio={selectedPortfolio}
          canDelete={canDelete}
          anchorElMenu1={anchorElMenu1}
          anchorElMenu2={anchorElMenu2}
          handleClosePortfolioOptions={handleClosePortfolioOptions}
          member={member}
          clsx={clsx}
        />
      </ul>
      <Divider />
      <ul>
        <TrashSection
          trashedProperties={trashedProperties}
          anchorElTrashMenu={anchorElTrashMenu}
          openTrashOptions={openTrashOptions}
          handleCloseTrashOptions={handleCloseTrashOptions}
          clsx={clsx}
        />
      </ul>
      <Divider />
      <ul>
        <MarketplacesSection
          marketplaces={marketplaces}
          sharedMarketplaces={sharedMarketplaces}
          orgId={orgId}
          marketplacesDropdownOpen={marketplacesDropdownOpen}
          toggleMarketplacesDropdown={toggleMarketplacesDropdown}
          handleMarketplace={handleMarketplace}
          activeMarketplaceId={activeMarketplaceId}
          openMarketplaceOptions={openMarketplaceOptions}
          selectedMarketplace={selectedMarketplace}
          anchorElMenu3={anchorElMenu3}
          handleCloseMarketplaceOptions={
            handleCloseMarketplaceOptions
          }
          urlAffiliate={urlAffiliate}
          clsx={clsx}
          member={member}
          activeOrg={session.me.activeOrg}
        />
      </ul>
      {session?.me?.housefoliosAdmin && (
        <>
          <ul>
            <Divider />
            <AdminSection
              adminDropdownOpen={adminDropdownOpen}
              toggleAdminDropdown={toggleAdminDropdown}
              handleOpenHousefoliosAdmin={handleOpenHousefoliosAdmin}
            />
            <Divider />
          </ul>
        </>
      )}
      {/* Affiliate (Property Edge Pro) Admin Section */}
      {session?.me?.activeOrg?.isAffiliate && (
        <ul>
          <li>
            <a
              id="leftNavPartner"
              href="#/"
              onClick={toggleAffiliateDropdown}
              data-nav-active={affiliateDropdownOpen || undefined}
            >
              <span data-hf="sidebar-icon">
                <FontAwesomeIcon icon={['fas', 'people-roof']} />
              </span>
              <span data-hf="sidebar-item-label">
                {session.me.activeOrg.isAffiliate.companyName} Admin
              </span>
              <span data-hf="sidebar-icon-indicator">
                <ChevronRightTwoToneIcon />
              </span>
            </a>
            <Collapse in={affiliateDropdownOpen}>
              <ul>
                <li>
                  <NavLink
                    to="/partnerportal"
                  >
                    <span data-hf="sidebar-icon">
                      <FontAwesomeIcon
                        size="sm"
                        icon={['fas', 'people-roof']}
                      />
                    </span>
                    <span data-hf="sidebar-item-label">
                      Dashboard
                    </span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/affiliate-reports"
                  >
                    <span data-hf="sidebar-icon">
                      <FontAwesomeIcon
                        size="sm"
                        icon={['fas', 'chart-pie']}
                      />
                    </span>
                    <span data-hf="sidebar-item-label">
                      Reports
                    </span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/affiliate-admin/clients"
                  >
                    <span data-hf="sidebar-icon">
                      <HelpTwoToneIcon />
                    </span>
                    <span data-hf="sidebar-item-label">
                      Client Support
                    </span>
                  </NavLink>
                </li>
                {session.me.activeOrg.isAffiliate.isRealeflow && (
                  <li>
                    <NavLink
                      to="/featureRequests"
                    >
                      <span data-hf="sidebar-icon">
                        <FontAwesomeIcon
                          size="sm"
                          icon={['fas', 'wand-magic-sparkles']}
                        />
                      </span>
                      <span data-hf="sidebar-item-label">
                        Feature Request
                      </span>
                    </NavLink>
                  </li>
                )}
                {session.me.activeOrg.isAffiliate.isRealeflow && (
                  <li>
                    <NavLink
                      to="/affiliate-admin/realeflow-audit"
                    >
                      <span data-hf="sidebar-icon">
                        <FontAwesomeIcon
                          size="sm"
                          icon={['far', 'file-excel']}
                        />
                      </span>
                      <span data-hf="sidebar-item-label">
                        Realeflow Audit
                      </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </Collapse>
          </li>
        </ul>
      )}
      {shouldShowUpgradeCTA && (
        <>
          <Divider />
          <Box
            onClick={() => setUpgradeDialogOpen(true)}
            data-hf="upgrade-to-hot-nav-item"
            sx={{
              cursor: 'pointer',
              mt: 3.5,
              mx: sidebarToggle ? 0.5 : 1.5,
              mb: 1.5,
              p: sidebarToggle ? 1 : 2,
              borderRadius: 2,
              border: isHotPlan ? '2px solid #ff7a18' : 'none',
              background: isHotPlan
                ? 'linear-gradient(135deg, #0f172a 0%, #111827 60%, #334155 120%)'
                : 'linear-gradient(135deg, #ff7a18 0%, #ff3d00 60%, #ffb703 120%)',
              boxShadow: isHotPlan
                ? '0 6px 18px rgba(2,6,23,.45)'
                : '0 6px 18px rgba(249,115,22,.35)',
              color: '#fff',
              position: 'relative',
              overflow: 'hidden',
              transition: 'all .2s ease',
              '&:hover': {
                boxShadow: isHotPlan
                  ? '0 10px 24px rgba(2,6,23,.6)'
                  : '0 10px 24px rgba(251,146,60,.5)',
                transform: 'translateY(-1px)',
              },
            }}
          >
            <Box
              data-hf="upgrade-box-content"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}
            >
              <FontAwesomeIcon
                icon={['fas', 'fire']}
                sx={{ fontSize: 18 }}
              />
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 700,
                  lineHeight: 1,
                  color: '#fff',
                }}
              >
                {isHotPlan ? 'Hot is active!' : 'Upgrade to Hot'}
              </Typography>
              <Chip
                label={isHotPlan ? 'Current plan' : 'Best value'}
                size="small"
                sx={{
                  ml: 'auto',
                  bgcolor: isHotPlan ? '#ff7a18' : 'rgba(0,0,0,.18)',
                  color: '#fff',
                  height: 22,
                  borderRadius: 1,
                }}
              />
            </Box>
            {sidebarToggle && (
              <Box
                data-hf="upgrade-box-collapsed"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                }}
              >
                <Box
                  sx={{
                    fontSize: 20,
                    backgroundColor: '#000',
                    width: '40px',
                    height: '40px',
                    color: '#fff',
                    borderRadius: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  🔥
                </Box>
              </Box>
            )}
            <Box data-hf="upgrade-box-description">
              <Typography
                variant="body2"
                sx={{ mt: 1, color: '#fff', opacity: 0.95 }}
              >
                {isHotPlan
                  ? 'You’re currently on Hot. Manage your plan and billing.'
                  : 'Unlock investor leads and unlimited skip tracing.'}
              </Typography>
              <Button
                onClick={(e) => {
                  e.stopPropagation()
                  setUpgradeDialogOpen(true)
                }}
                variant={isHotPlan ? 'outlined' : 'contained'}
                size="small"
                fullWidth
                sx={{
                  mt: 1.5,
                  bgcolor: isHotPlan ? 'transparent' : '#0b1020',
                  color: isHotPlan ? '#fff' : '#fff',
                  borderColor: isHotPlan ? '#ff7a18' : 'transparent',
                  fontWeight: 700,
                  '&:hover': isHotPlan
                    ? {
                        bgcolor: 'rgba(255,122,24,.12)',
                        borderColor: '#ff7a18',
                      }
                    : { bgcolor: '#0f172a' },
                }}
              >
                {isHotPlan ? 'Manage plan' : 'Upgrade now'}
              </Button>
            </Box>
          </Box>
          <UnifiedSubscribeDialog
            open={upgradeDialogOpen}
            onClose={() => setUpgradeDialogOpen(false)}
            session={session}
            initialIsHot={isHotPlan ? undefined : true}
            initialYearly={isHotPlan ? undefined : true}
          />
        </>
      )}
    </Box>
  )
}

export default SidebarNavigation
